/* eslint-disable import/no-default-export */
export default {
  'AgenticDuoChat.chatCancelLabel': 'Cancel',
  'AgenticDuoChat.chatDefaultPredefinedPromptsChangePassword':
    'How do I change my password in GitLab?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'AgenticDuoChat.chatDefaultTitle': 'GitLab Duo Agentic Chat',
  'AgenticDuoChat.chatDisclamer':
    'Chat can autonomously change code. Responses and changes can be inaccurate. Review carefully.',
  'AgenticDuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Agentic Chat, your personal AI-powered assistant. How can I help you today?',
  'AgenticDuoChat.chatHistoryTitle': 'Chat history',
  'AgenticDuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Agentic Chat',
  'AgenticDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'AgenticDuoChat.chatSubmitLabel': 'Send chat message.',
  'AgenticDuoChat.overLimitCharacterCountMessage': null,
  'AgenticDuoChat.remainingCharacterCountMessage': null,
  'AgenticToolApprovalFlow.defaultDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'AgenticToolApprovalModal.approveText': 'Approve',
  'AgenticToolApprovalModal.defaultDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'AgenticToolApprovalModal.denyText': 'Deny',
  'AgenticToolApprovalModal.title': 'Tool Approval Required',
  'AgenticToolApprovalModal.toolLabel': 'Tool:',
  'AgenticToolApprovalModal.toolUnknown': 'Unknown',
  'AgenticToolRejectionModal.backText': 'Back',
  'AgenticToolRejectionModal.description':
    'You are about to reject the tool execution. Would you like to provide a reason?',
  'AgenticToolRejectionModal.label': 'Rejection reason',
  'AgenticToolRejectionModal.placeholder': "Explain why you're rejecting this tool execution...",
  'AgenticToolRejectionModal.submitText': 'Submit Rejection',
  'AgenticToolRejectionModal.title': 'Provide Rejection Reason',
  'DuoChat.chatBackLabel': 'Back to history',
  'DuoChat.chatBackToChatToolTip': 'Back to chat',
  'DuoChat.chatCancelLabel': 'Cancel',
  'DuoChat.chatDefaultPredefinedPromptsChangePassword': 'How do I change my password in GitLab?',
  'DuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'DuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'DuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'DuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'DuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Chat, your personal AI-powered assistant. How can I help you today?',
  'DuoChat.chatHistoryInfo': 'Inactive chats are deleted after 30 days.',
  'DuoChat.chatHistoryToolTip': 'Chat history',
  'DuoChat.chatNewLabel': 'New chat',
  'DuoChat.chatNewToolTip': 'New chat',
  'DuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Chat',
  'DuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'DuoChat.chatSubmitLabel': 'Send chat message.',
  'DuoChat.chatTitle': 'GitLab Duo Chat',
  'DuoChat.closeChatHeaderLabel': 'Close chat',
  'DuoChat.emptyHistoryAlt':
    'Clock icon with circular arrow, indicating chat history or time-based functionality',
  'DuoChat.emptyHistoryCopy': 'Your previous chats will appear here.',
  'DuoChat.emptyHistoryTitle': 'See your chat history',
  'DuoChat.openChatLabel': 'Open chat: %{title}',
  'DuoChat.threadDeleteLabel': 'Delete this chat',
  'DuoChatContextItemDetailsModal.contentErrorMessage': 'Item content could not be displayed.',
  'DuoChatContextItemDetailsModal.title': 'Preview',
  'DuoChatContextItemMenu.emptyStateMessage': 'No results found',
  'DuoChatContextItemMenu.loadingMessage': 'Loading...',
  'DuoChatContextItemMenu.searchInputPlaceholder': 'Search %{categoryLabel}...',
  'DuoChatContextItemMenu.selectedContextItemsTitle': 'Included references',
  'DuoChatContextItemPopover.DisabledReason': 'This item is disabled',
  'DuoChatConversation.newChat': 'New chat',
  'DuoChatLoader.gitlabDuo': 'GitLab Duo',
  'DuoChatLoader.loaderLoadingMessage': '%{tool} is %{transition} an answer',
  'DuoChatLoader.loaderLoadingTransitionsFinding': 'finding',
  'DuoChatLoader.loaderLoadingTransitionsGenerating': 'generating',
  'DuoChatLoader.loaderLoadingTransitionsProducing': 'producing',
  'DuoChatLoader.loaderLoadingTransitionsWorkingOn': 'working on',
  'DuoChatMessage.SelectedContextItemsTitleAssistantMessage': null,
  'DuoChatMessage.SelectedContextItemsTitleUserMessage': null,
  'DuoChatMessage.actionLabel': 'Action',
  'DuoChatMessage.branchLabel': 'Branch',
  'DuoChatMessage.chatMessageCopied': 'Copied',
  'DuoChatMessage.chatMessageCopyToClipboard': 'Copy to clipboard',
  'DuoChatMessage.commitMessageLabel': 'Commit message',
  'DuoChatMessage.contentLabel': 'Content',
  'DuoChatMessage.filePathLabel': 'File path',
  'DuoChatMessage.fromDuo': 'Duo:',
  'DuoChatMessage.fromMe': 'Me:',
  'DuoChatMessage.modalAlertText':
    'GitLab team members cannot view your conversation. Please be as descriptive as possible.',
  'DuoChatMessage.modalBetterResponse': 'How the response might better meet your needs.',
  'DuoChatMessage.modalDidWhat': 'What were you doing?',
  'DuoChatMessage.modalImproveWhat': 'How could the response be improved?',
  'DuoChatMessage.modalInteraction': 'The situation in which you interacted with GitLab Duo Chat.',
  'DuoChatMessage.modalMessageError': 'Error sending the message',
  'DuoChatMessage.modalTitle': 'Give feedback on GitLab Duo Chat',
  'DuoChatMessage.projectLabel': 'Project',
  'DuoChatMessage.ranTerminalCommand': 'Ran terminal command',
  'DuoChatMessage.startBranchLabel': 'Start branch',
  'DuoChatMessageSources.messageSources': null,
  'DuoRecentCollapsable.viewAllText': 'View All',
  'GlDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'GlDuoChat.chatHistoryTitle': 'Chat history',
  'MessageToolApproval.approveText': 'Approve',
  'MessageToolApproval.approvingText': 'Approving...',
  'MessageToolApproval.cancelText': 'Cancel',
  'MessageToolApproval.denialReasonLabel': 'Rejection reason',
  'MessageToolApproval.denialReasonPlaceholder':
    "Tell Duo why you're rejecting this tool execution...",
  'MessageToolApproval.denyText': 'Deny',
  'MessageToolApproval.denyingText': 'Denying...',
  'MessageToolApproval.noParametersText': 'No parameters will be sent with this request.',
  'MessageToolApproval.parametersText': 'Request',
  'MessageToolApproval.toolApprovalDescription':
    'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?',
  'MessageToolApproval.toolApprovalTitle':
    'Duo would like to execute a tool. Do you want to proceed?',
  'MessageToolApproval.toolLabel': 'Tool:',
  'MessageToolApproval.toolUnknown': 'Unknown',
};
